module.exports = __webpack_public_path__ + "media/cloth_1.13975778.mp3";